<template>
  <div class="sky-page-function-view">
    <div class="sky-page-form">
      <el-form
        ref="thride_terminal_from"
        class="thride-server-from"
        :model="terminalForm"
        :rules="rules"
        label-width="158px"
      >
        <el-form-item class="wsp-padding-tb-6 ">
          <el-button type="primary" @click="onSubmit">确定</el-button>
          <el-button @click="onCancle">取消</el-button>
        </el-form-item>
        <el-form-item label="使用场景" prop="sceneId">
          <el-select v-model="terminalForm.sceneId" default-first-option>
            <el-option
              v-for="item in scenes"
              :key="item.sceneId"
              :label="item.sceneName"
              :value="item.sceneId"
            ></el-option>
          </el-select>
          <div class="font-size-10 font-weight-300">请选择你使用的场景</div>
        </el-form-item>
        <el-form-item label="终端型号" prop="model">
          <el-input v-model="terminalForm.model" custom-auto-focus></el-input>
          <div class="font-size-10 font-weight-300">例如：华硕X405UA</div>
        </el-form-item>
        <el-form-item label="终端厂商" prop="manufacturer">
          <el-input v-model="terminalForm.manufacturer" custom-auto-focus></el-input>
          <div class="font-size-10 font-weight-300">例如：联想</div>
        </el-form-item>
        <el-form-item label="操作系统" prop="operationSystemObj">
          <el-select v-model="terminalForm.operationSystemObj">
            <el-option v-for="item in osList" :key="item.id" :label="item.label" :value="item.id"></el-option>
          </el-select>
          <div class="font-size-10 font-weight-300">请选择终端所使用的操作系统</div>
        </el-form-item>
        <el-form-item label="用途" prop="usage">
          <el-select v-model="terminalForm.usage">
            <el-option v-for="item in usageList" :key="item.id" :label="item.label" :value="item.id"></el-option>
          </el-select>
          <div class="font-size-10 font-weight-300">请选择终端的用途</div>
        </el-form-item>
        <el-form-item label="CPU" prop="cpu">
          <el-input v-model="terminalForm.cpu" custom-auto-focus></el-input>
          <div class="font-size-10 font-weight-300">例如：i5-13490F</div>
        </el-form-item>
        <el-form-item label="CPU核数" prop="cpuCore">
          <el-input-number v-model="terminalForm.cpuCore" :min="0"></el-input-number>
          <div class="font-size-10 font-weight-300">请填写核数</div>
        </el-form-item>
        <el-form-item label="内存(G)" prop="cpuTotalThreads">
          <el-input-number v-model="terminalForm.memory" :min="0"></el-input-number>
          <div class="font-size-10 font-weight-300">请填写内存大小，单位：G</div>
        </el-form-item>
        <el-form-item label="硬盘大小(G)" prop="memory">
          <el-input-number v-model="terminalForm.diskSize" :min="0"></el-input-number>
          <div class="font-size-10 font-weight-300">请填写硬盘大小，单位：G</div>
        </el-form-item>
        <el-form-item label="显卡信息" prop="nicsInfo">
          <el-input v-model="terminalForm.gpuModel" custom-auto-focus></el-input>
          <div class="font-size-10 font-weight-300">请填写显卡信息</div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { Form, FormItem, Input, InputNumber, Button, Select, Option } from 'element-ui'

import { action } from 'sky-engine/api'

import { OSTYPE_MNG } from '@/api/apiModules'

// import lang from '@/lang'
export default {
  name: 'SkyThrideterminalForm',
  components: {
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Input.name]: Input,
    [Select.name]: Select,
    [Option.name]: Option,
    [InputNumber.name]: InputNumber,
    [Button.name]: Button
  },
  props: {
    params: {
      type: Object,
      default: function() {
        return {}
      }
    },
    scenes: {
      type: Array,
      default: function() {
        return []
      }
    }
  },
  data: function() {
    return {
      rules: {
        sceneId: [{ required: true, message: '请选择场景', trigger: 'change' }],
        model: [{ required: true, message: '请输入终端型号', trigger: 'blur' }],
        usage: [{ required: true, message: '用途必选', trigger: 'change' }],
        cpu: [{ required: true, message: 'CPU信息必选', trigger: 'blur' }],
        operationSystemObj: [{ required: true, message: '操作系统必选', trigger: 'change' }]
      },
      usageList: [
        {
          id: '利旧VDI客户端',
          label: '利旧VDI客户端'
        },
        {
          id: '利旧TCI客户端',
          label: '利旧TCI客户端'
        },
        {
          id: '运行VDI云桌面',
          label: '运行VDI云桌面'
        },
        {
          id: '运行云应用',
          label: '运行云应用'
        },
        {
          id: '运行云坞',
          label: '运行云坞'
        }
      ],
      osList: [],
      osMap: {},
      terminalForm: {
        sceneId: this.scenes.length > 0 ? this.scenes[0].sceneId : null,
        cpuCore: 1,
        diskSize: 0,
        diskCount: 1,
        memory: 0,
        supportsUefi: true,
        cpu: null,
        manufacturer: null,
        model: null,
        operationSystemObj: null
      }
    }
  },
  mounted() {
    this.getData()
  },
  created() {
    if (this.scenes.length > 0) {
      this.selectScene = this.scenes[0]
    }
  },
  methods: {
    getData() {
      action(OSTYPE_MNG, 'findAllActive').then(response => {
        this.osList = response.data.content.itemArr.map(item => {
          this.osMap[item.id] = item.osType
          return {
            id: item.id,
            label: item.osType
          }
        })
      })
    },
    onSubmit() {
      this.terminalForm.operationSystem = this.osMap[this.terminalForm.operationSystemObj]
      this.terminalForm.osTypeId = this.terminalForm.operationSystemObj

      this.$refs.thride_terminal_from.validate(valid => {
        if (valid) {
          this.$emit('addSelect', {
            select: this.terminalForm,
            sceneId: this.terminalForm.sceneId,
            type: 'ThrideTerminal'
          })
        } else {
          this.$emit('unSelect', {
            select: this.terminalForm,
            sceneId: this.terminalForm.sceneId,
            type: 'ThrideTerminal'
          })
          return false
        }
      })
    },
    onCancle() {
      this.$parent.$parent.closerDrawer()
    }
  }
}
</script>

<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';
@include b(page-function-view) {
  height: 100%;
  .sky-page-form {
    width: 65%;
    .thride-server-from {
      .el-form-item {
        margin-bottom: 0 !important;
      }
      .cusotm-header-header {
        text-align: center;
        line-height: 24px;
        color: #9d9696;
      }
    }
  }
}
</style>
